import React, { useState, useRef, useEffect } from "react";

// Add the callbackFunction prop type
interface SwipableButtonProps {
  heading: number;
  setHeading: (newHeading: number) => void; // Optional callback function
}

const HeadingSelector: React.FC<SwipableButtonProps> = ({ heading, setHeading }) => {
  // const [heading, setHeading] = useState(0); // Store heading in degrees
  const circleRef = useRef(null);

  // Function to calculate the heading based on mouse position
  const calculateHeading = (event: MouseEvent | TouchEvent) => {
    if (circleRef.current) {
      // Get the position based on the event type (MouseEvent or TouchEvent)
      const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
      const clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;

      const rect = (circleRef.current as any).getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const mouseX = clientX;
      const mouseY = clientY;

      const radians = Math.atan2(mouseY - cy, mouseX - cx);
      const deg = (radians * (180 / Math.PI) + 360) % 360; // Convert to degrees and normalize to 0-360
      return deg;
    }
    return 0;
  };

  // Handle mouse down event
  const handleMouseDown = (event: React.MouseEvent | React.TouchEvent) => {
    setHeading(0);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchmove", handleMouseMove);
    window.addEventListener("touchend", handleMouseUp);
  };

  // Handle mouse move event
  const handleMouseMove = (event: MouseEvent | TouchEvent) => {
    const newHeading = calculateHeading(event);
    setHeading(newHeading);
  };

  // Handle mouse up event
  const handleMouseUp = () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
    window.removeEventListener("touchmove", handleMouseMove);
    window.removeEventListener("touchend", handleMouseUp);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <svg
        ref={circleRef}
        width="200"
        height="200"
        onMouseDown={handleMouseDown}
        onTouchStart={handleMouseDown}
        style={{ cursor: "pointer" }}
      >
        <circle cx="100" cy="100" r="90" fill="lightgrey" />
        <line
          x1="100"
          y1="100"
          x2={100 + 90 * Math.cos((heading - 90) * (Math.PI / 180))}
          y2={100 + 90 * Math.sin((heading - 90) * (Math.PI / 180))}
          stroke="#000000"
          strokeWidth="5"
        />
        <circle
          cx={100 + 90 * Math.cos((heading - 90) * (Math.PI / 180))}
          cy={100 + 90 * Math.sin((heading - 90) * (Math.PI / 180))}
          r="5"
          fill="#ffde00"
        />
      </svg>
      <div>
        <span>Heading: {Math.round(heading)}°</span>
      </div>
    </div>
  );
};

export default HeadingSelector;
